import React, { useState } from 'react';
import Barcode from 'react-barcode';

function GenerateBarcode(){
  const [barcodeValue, setBarcodeValue] = useState('');

    const handleInputChange = (e) => {
        setBarcodeValue(e.target.value);
    };
    const handlePrint = () => {
    const printContents = document.getElementById('print').innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    setTimeout(() => {
        window.location.reload();
    }, 1000);
    document.body.innerHTML = originalContents;
    };

  return (
  <section className="container mt-4">
  <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i className="fa-solid fa-barcode"
        aria-hidden="true" style={{color: 'red'}}></i> Generate Barcode</h3>
    <div className="row mt-4">
      <input
        className="form-control"
        type="text"
        value={barcodeValue}
        onChange={handleInputChange}
        placeholder="Enter barcode value"
      />
      <div className="text-center mt-5" id="print">
      <Barcode value={barcodeValue} />
      </div>
    </div>
<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
<button type="button" className="btn btn-primary mt-4"
              onClick={handlePrint}
              >
               Print
              </button>
              </div>
    </section>
  );
};

export default GenerateBarcode;
